import { render, staticRenderFns } from "./ProjectDataCreate.vue?vue&type=template&id=0ab5be1f&scoped=true&"
import script from "./ProjectDataCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectDataCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDataCreate.vue?vue&type=style&index=0&id=0ab5be1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5be1f",
  null
  
)

export default component.exports